import axios from "axios";
import axiosClient from "./axios-client/axiosClient.jsx";
import { utils } from "../utils/Utils";

class LoginAPI {
  login(username, password) {
    const headers = {};
    const requestBody = {
      username: username,
      password: password,
    };

    return axios.post(
      process.env.REACT_APP_BASE_API_URL + "/login",
      requestBody,
      {
        headers: headers,
      },
    );
  }

  registerAccount(requestData) {
    const registerRequest = {
      fname: requestData.fName,
      lname: requestData.lName,
      email: requestData.email,
      phone: requestData.countryCode + requestData.phoneNumber,
      password: requestData.password,
      domicile: requestData.domicile,
      language: requestData.language,
      preferred_currency: requestData.preferredCurrency,
      person_type: requestData.accountType,
      ref_code: "1pxtb2e02jue1",
    };

    const headers = {
      "x-api-key": utils.getXAPIKey(),
    };

    return axios.post(
      process.env.REACT_APP_BASE_API_URL + "/register/v2/simple",
      registerRequest,
      {
        headers: headers,
      },
    );
  }

  //only coorporate
  registerAccount2(requestData) {
    const registerRequest = {
      fname: requestData.fName,
      lname: requestData.lName,
      email: requestData.email,
      phone: requestData.countryCode + requestData.phoneNumber,
      password: requestData.password,
      domicile: requestData.domicile,
      language: requestData.language,
      preferred_currency: requestData.preferredCurrency,
      onboarding_code: requestData.onboardingCode,
      ref_code: "1pxtb2e02jue1",
    };

    const headers = {
      "x-api-key": utils.getXAPIKey(),
    };

    return axios.post(
      process.env.REACT_APP_BASE_API_URL + "/register/register-business",
      registerRequest,
      {
        headers: headers,
      },
    );
  }

  registerCorporateAccount(clientId, requestData) {
    console.log("registerCorporateAccount", clientId, requestData);

    const formData = new FormData();

    // Append text fields

    formData.append("clientId", clientId);

    formData.append("business_name", requestData.businessName);
    formData.append("trade_name", requestData.tradeName);

    formData.append("business_address_1", requestData.businessAddress1);
    formData.append("business_address_2", requestData.businessAddress2);
    formData.append("country", requestData.country);
    formData.append("region", requestData.region);
    formData.append("city", requestData.city);
    formData.append("postal_code", requestData.postalCode);

    formData.append("incorporation_date", requestData.incorporationDate || "");
    formData.append("incorporation_country", requestData.incorporationCountry);

    formData.append("is_regulated", requestData.isRegulated);
    formData.append("is_licensed", requestData.isLicensed);

    formData.append("nature_of_business", requestData.natureOfBusiness);
    formData.append("serviced_countries", requestData.servicedCountries);

    formData.append(
      "operates_in_restricted_countries",
      requestData.operatesInRestrictedCountries,
    );
    formData.append("has_peps", requestData.hasPEPs);

    formData.append("corporate_phone", requestData.corporatePhone);
    formData.append("customer_service_phone", requestData.customerServicePhone);
    formData.append("business_type", requestData.businessType);
    formData.append("business_number", requestData.businessNumber);
    formData.append("company_websites", requestData.companyWebsites);
    formData.append("marketing_websites", requestData.marketingWebsites);

    formData.append("submitter_first_name", requestData.submitterFirstName);
    formData.append("submitter_last_name", requestData.submitterLastName);
    formData.append("submitter_email", requestData.submitterEmail);

    const fileFields = {
      articles_of_incorporation: requestData.articlesOfIncorporation,
      shareholder_register: requestData.shareholderRegister,
      certificate_of_incorporation: requestData.certificateOfIncorporation,
      certificate_of_good_standing: requestData.certificateOfGoodStanding,
      business_description_letter: requestData.businessDescriptionLetter,
      last_three_bank_statements: requestData.lastThreeBankStatements,
      proof_of_business_address: requestData.proofOfBusinessAddress,
      financial_statements_or_tax_returns:
        requestData.financialStatementsOrTaxReturns,
      corporate_organizational_structure:
        requestData.corporateOrganizationalStructure,
      license: requestData.license,
      aml_kyc_policies: requestData.amlKycPolicies,
      tax_document: requestData.taxDocument,
      authorized_applicant_id: requestData.identificationAuthorizedApplicant,
      beneficial_owners_id: requestData.identificationOfBeneficialOwners,
    };

    for (const [key, value] of Object.entries(fileFields)) {
      if (value) {
        formData.append(key, value);
      }
    }

    // Debug FormData content properly
    const formDataPreview = {};
    for (const [key, value] of formData.entries()) {
      formDataPreview[key] =
        value instanceof File ? `[File: ${value.name}]` : value;
    }
    console.log("registerCorporateAccount formData", formDataPreview);

    // Axios request
    const headers = {
      "x-api-key": utils.getXAPIKey(),
      "Content-Type": "multipart/form-data",
    };

    return axios.post(
      process.env.REACT_APP_BASE_API_URL + "/register/register-coorporate",
      formData,
      { headers },
    );
  }

  getClientConfig(token) {
    const headers = {
      headers: { Authorization: `Bearer ${token}` },
    };

    return axiosClient.get(
      process.env.REACT_APP_BASE_API_URL + "/client/config",
      headers,
    );
  }

  confirmPhone(token) {
    const headers = {
      headers: { Authorization: `Bearer ${token}` },
    };

    const requestBody = {};

    return axios.post(
      process.env.REACT_APP_BASE_API_URL + "/register/confirmPhone",
      requestBody,
      headers,
    );
  }

  confirmPhoneNotLoggedin(phone, language) {
    const headers = {
      headers: {},
    };

    const requestBody = {
      sendto: phone,
      language: language,
      code_validation: "2oj201",
    };

    return axios.post(
      process.env.REACT_APP_BASE_API_URL + "/register/confirmPhoneUnsigned",
      requestBody,
      headers,
    );
  }

  validatePhone(token, code) {
    const headers = {
      headers: { Authorization: `Bearer ${token}` },
    };
    const requestBody = {
      code: code,
    };

    return axios.post(
      process.env.REACT_APP_BASE_API_URL + "/register/validatePhone",
      requestBody,
      headers,
    );
  }

  validatePhoneNotLoggedIn(code, phone) {
    const headers = {
      headers: {},
    };

    const requestBody = {
      code: code,
      send_to: phone,
      language: "eng",
      code_validation: "dq322",
    };

    return axios.post(
      process.env.REACT_APP_BASE_API_URL + "/register/validatePhoneUnsigned",
      requestBody,
      headers,
    );
  }

  confirmEmail(token) {
    const headers = {
      headers: { Authorization: `Bearer ${token}` },
    };
    const requestBody = {};

    return axios.post(
      process.env.REACT_APP_BASE_API_URL + "/register/confirmEmail",
      requestBody,
      headers,
    );
  }

  confirmEmailNotLoggedIn(email, language) {
    const headers = {};
    const requestBody = {
      sendto: email,
      language: language,
      code_validation: "2oj201",
    };

    return axios.post(
      process.env.REACT_APP_BASE_API_URL + "/register/confirmEmailUnsigned",
      requestBody,
      headers,
    );
  }

  validateEmail(token, code) {
    const headers = {
      headers: { Authorization: `Bearer ${token}` },
    };
    const requestBody = {
      code: code,
    };

    return axios.post(
      process.env.REACT_APP_BASE_API_URL + "/register/validateEmail",
      requestBody,
      headers,
    );
  }

  validateEmailNotLoggedIn(code, email) {
    const headers = {
      headers: {},
    };
    const requestBody = {
      code: code,
      send_to: email,
      language: "eng",
      code_validation: "dq322",
    };

    return axios.post(
      process.env.REACT_APP_BASE_API_URL + "/register/validateEmailUnsigned",
      requestBody,
      headers,
    );
  }

  validateAuthPhone(token, code) {
    const headers = {
      headers: { Authorization: `Bearer ${token}` },
    };
    const requestBody = {
      code: code,
    };

    return axios.post(
      process.env.REACT_APP_BASE_API_URL +
        "/register/gen_2fa_qrcode_with_smscode",
      requestBody,
      headers,
    );
  }

  validateAuthEmail(token, code) {
    const headers = {
      headers: { Authorization: `Bearer ${token}` },
    };
    const requestBody = {
      code: code,
    };

    return axios.post(
      process.env.REACT_APP_BASE_API_URL +
        "/register/gen_2fa_qrcode_with_emailcode",
      requestBody,
      headers,
    );
  }

  validateAuth(token, code) {
    const headers = {
      headers: { Authorization: `Bearer ${token}` },
    };
    const requestBody = {
      code: code,
    };

    return axios.post(
      process.env.REACT_APP_BASE_API_URL + "/register/validate_2fa_code",
      requestBody,
      headers,
    );
  }

  forgotPassword(email) {
    const headers = {};
    const requestBody = {
      email: email,
    };

    return axios.post(
      process.env.REACT_APP_BASE_API_URL + "/register/lost_pwd",
      requestBody,
      headers,
    );
  }

  logout(token) {
    const headers = {
      headers: { Authorization: `Bearer ${token}` },
    };
    const requestBody = {};

    return axios.post(
      process.env.REACT_APP_BASE_API_URL + "/logout",
      requestBody,
      headers,
    );
  }
}

export const loginAPI = new LoginAPI();
